<div class="mat-dialog-content">
  <img [src]="dialogData.imgUrl" alt="Image" />
</div>

